import React, { useState } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

const PlanTypeInput = ({ onChange, formData, disabled = false }) => {
  const [options, setOptions] = useState([
    { value: 'prepaid', label: 'Prepaid' },
    { value: 'postpaid', label: 'Postpaid' },
  ]);

  const handleChange = (e) => {
    const newType = e.target.value;
    const update = { ...formData, type: newType };

    if (newType === 'prepaid') {
      update.pricing_model = 'licensed';
      update.billing_schema = null;
      delete update.tiers;
      delete update.tiers_mode;
    }

    onChange(update);
  };

  return (
    <FormControl fullWidth required>
      <InputLabel shrink>Type</InputLabel>
      <Select
        label="Type"
        value={formData.type || ''}
        onChange={handleChange}
        variant={'outlined'}
        size="small"
        disabled={disabled}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default PlanTypeInput;
